import React, { useEffect } from "react";
import { useOutlet, useNavigate } from "react-router-dom";
import { usePageTitle } from "hooks/usePageTitle";

export const AuthLayout = () => {
  const outlet = useOutlet();
  const navigate = useNavigate();
  usePageTitle();

  useEffect(() => {
    const handleAuthNavigation = (event: CustomEvent) => {
      navigate(event.detail.route);
    };

    window.addEventListener(
      "authNavigation",
      handleAuthNavigation as EventListener
    );

    return () => {
      window.removeEventListener(
        "authNavigation",
        handleAuthNavigation as EventListener
      );
    };
  }, [navigate]);

  return <>{outlet}</>;
};

export default AuthLayout;
